import SaveQuoteCheckType from '@/helpers/enums/saveQuoteCheckType'
import CheckCustomerType from '@/mixins/checkCustomerType.js'
import CheckExpireDate from '@/mixins/checkExpireDate.js'
import CheckExpectedDeliveryDate from '@/mixins/checkExpectedDeliveryDate'
export default {
  mixins: [CheckCustomerType, CheckExpireDate, CheckExpectedDeliveryDate],
  methods: {
    checkSaveQuoteChecks(checkType, forceLiBKnown) {
      switch (checkType) {
        case SaveQuoteCheckType.checkCustomerType:
          return (
            this.customerTypeCheck() &&
            this.expireDateCheck() &&
            this.expectedDeliveryDateCheck(forceLiBKnown)
          )
        case SaveQuoteCheckType.checkExpireDate:
          return this.expireDateCheck() && this.expectedDeliveryDateCheck(forceLiBKnown)
        case SaveQuoteCheckType.checkExpectedDeliveryDate:
          return this.expectedDeliveryDateCheck(forceLiBKnown)
        default:
          return true
      }
    },
  },
}
